const lang = {
  state: {
    lang: 'en'
  },
  mutations: {
    setLang: (state, lang) => {
      console.log('setLang-lang',lang)
      state.lang = lang
    }
  },
  actions: {
    setLang({ commit }, lang) {
      console.log('lang',lang)
      commit('setLang', lang)
    }
  },
  getters: {
    lang(state) {
        return state.lang
      }
  }
}

export default lang
